import * as client from '../../services/client';
import { TYPES } from '../../common/constants';

const startLoadingDownloadServiceRequestList = () => ({
  type: TYPES.START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV,
});
export const clearLoadingDownloadServiceRequestList = () => ({
  type: TYPES.CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV,
});

const stopLoadingDownloadServiceRequestList = () => ({
  type: TYPES.STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV,
});

const fetchDownloadServiceRequestListCSVDone = (payload) => ({
  type: TYPES.FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE,
  payload,
});

export const fetchPropertyServiceRequestCSVExportDownloadList =
  (propertyId, userId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchPropertyServiceRequestCSVExportDownloadList(
        propertyId,
        userId,
        role,
        searchString
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      })
      .catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      });
  };

export const fetchSuiteServiceRequestCSVExportDownloadList =
  (suiteId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchSuiteServiceRequestCSVExportDownloadList(
        suiteId,
        role,
        searchString
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      })
      .catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      });
  };

export const fetchContactServiceRequestCSVExportDownloadList =
  (userId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchContactServiceRequestCSVExportDownloadList(
        userId,
        role,
        searchString
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      })
      .catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      });
  };

export const fetchCatalogItemServiceRequestCSVExportDownloadList =
  (itemId, userId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchCatalogItemServiceRequestCSVExportDownloadList(
        itemId,
        userId,
        role,
        searchString
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      })
      .catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      });
  };

export const fetchCommonAreaServiceRequestCSVExportDownloadList =
  (commonAreaId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchCommonAreaServiceRequestCSVExportDownloadList(
        commonAreaId,
        role,
        searchString
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      })
      .catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      });
  };
